import React, { Component } from 'react';
import { API_ENDPOINT } from '../../constants';
import ErrorModal from '../../components/errorModal';
import { Player, Controls } from "@lottiefiles/react-lottie-player";
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import DeleteModal from '../../components/deleteModal';
import Checkbox from '../../components/forms/fields/checkbox';

function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
class SyncEventsFromCF extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props.initialData,
            selectedGroups: [],
            loadingSyncEvents: [],
            syncedEventsResponses: []
        };

    }


    componentDidMount() {

    }
    componentDidUpdate(prevProps) {

    }

    toggle = () => {
        if (this.props.toggle) {
            this.props.toggle();
        }
    }
    checkEventsForSync = () => {
        let selectedGroups = this.state.selectedGroups;
        if (selectedGroups?.length === 0) {
            this.setState({ error: 'Please select at least one group' });
            return;
        }
        this.setState({ loading: true }, () => {
            fetch(`${API_ENDPOINT}/data/webDocSettings/check-events-for-sync`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({ selectedGroups: selectedGroups })
            }).then(parseJSON).then(({ result, status }) => {
                if (status === 200) {
                    if (result?.length) {
                        this.setState({ loading: false, eventsForSync: result });
                    } else {
                        this.setState({ loading: false, error: 'No events found for sync' });
                    }

                    if (this.props.onUpdate) {
                        this.props.onUpdate();
                    }

                } else {
                    this.setState({ loading: false, error: result.message || result?.error });
                }

            }).catch((err) => {
                this.setState({ loading: false, error: err.message });
            })
        });

    }
    syncEvent = (event) => {
        if (!event?.eventId) return;
        let loadingSyncEvents = this.state.loadingSyncEvents;
        if (loadingSyncEvents.includes(event.eventId)) return;
        loadingSyncEvents.push(event.eventId);
        let syncedEventsResponses = this.state.syncedEventsResponses;
        if (syncedEventsResponses.find((obj) => obj.eventId === event.eventId)) {
            syncedEventsResponses = syncedEventsResponses.filter((obj) => obj.eventId !== event.eventId);
        }


        this.setState({ loadingSyncEvents, syncedEventsResponses }, () => {
            fetch(`${API_ENDPOINT}/data/webDocSettings/sync-event`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({ eventId: event.eventId })
            }).then(parseJSON).then(({ result, status }) => {
                if (result?.error) {
                    let syncedEventsResponses = this.state.syncedEventsResponses;
                    loadingSyncEvents = this.state.loadingSyncEvents;
                    const response = {
                        eventId: event.eventId,
                        success: false,
                        message: result?.error
                    }
                    syncedEventsResponses.push(response);
                    loadingSyncEvents = loadingSyncEvents.filter((id) => id !== event.eventId);
                    this.setState({ loadingSyncEvents, syncedEventsResponses });
                } else {
                    let syncedEventsResponses = this.state.syncedEventsResponses;
                    loadingSyncEvents = this.state.loadingSyncEvents;
                    const response = {
                        eventId: event.eventId,
                        success: true
                    }
                    syncedEventsResponses.push(response);
                    loadingSyncEvents = loadingSyncEvents.filter((id) => id !== event.eventId);
                    this.setState({ loadingSyncEvents, syncedEventsResponses });


                    if (this.props.onUpdate) {
                        this.props.onUpdate();
                    }
                }

            }).catch((err) => {
                let syncedEventsResponses = this.state.syncedEventsResponses;
                loadingSyncEvents = this.state.loadingSyncEvents;
                const response = {
                    eventId: event.eventId,
                    success: false
                }
                syncedEventsResponses.push(response);
                loadingSyncEvents = loadingSyncEvents.filter((id) => id !== event.eventId);
                this.setState({ loadingSyncEvents, syncedEventsResponses });
            })
        })
    }

    syncAllNotSyncedEvents = () => {
        let selectedGroups = this.state.selectedGroups;
        if (selectedGroups?.length === 0) {
            this.setState({ error: 'Please select at least one group' });
            return;
        }
        this.setState({ loading: true }, () => {
            fetch(`${API_ENDPOINT}/data/webDocSettings/sync-all-not-synced-events`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({ selectedGroups: selectedGroups })
            }).then(parseJSON).then(({ result, status }) => {
                if (status === 200) {
                    let setObj = { loading: false };
                    if (this.state.eventsForSync) {
                        setObj.eventsForSync = null;
                    }
                    if (result?.length) {
                        setObj.syncedEvents = result;
                    } else {
                        setObj.error = 'No events found for sync';
                    }
                    this.setState(setObj);

                    if (this.props.onUpdate) {
                        this.props.onUpdate();
                    }

                } else {
                    this.setState({ loading: false, error: result.message || result?.error });
                }

            }).catch((err) => {
                this.setState({ loading: false, error: err.message });
            })
        });

    }

    render() {
        const isOpen = this.props.isOpen;
        const groups = this.props.groups?.filter(group => group?.webdoc?.active)?.map((group, index) => {
            let selected = this.state.selectedGroups?.includes(group._id);
            return {
                _id: group._id,
                name: group.name,
                alias: group.alias,
                selected: selected
            }
        });
        const eventsForSync = this.state.eventsForSync?.length > 0 ? this.state.eventsForSync : null;
        const syncedEvents = this.state.syncedEvents?.length > 0 ? this.state.syncedEvents : null;
        return (
            <div>
                {
                    this.state.loading ?
                        <div className="whole-screen-loader-wrap">
                            <div className="loader-wrap">
                                <Player
                                    autoplay={true}
                                    loop={true}
                                    renderer={'svg'}
                                    src="/lf30_editor_l5cxzdyf.json"
                                    style={{ height: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px", width: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px" }}
                                ></Player>

                            </div>
                        </div>
                        :
                        null
                }
                {
                    this.state.error ?
                        <ErrorModal
                            isOpen={this.state.error ? true : false}
                            toggle={() => this.setState({ error: null })}
                        >
                            {this.state.error}
                        </ErrorModal>
                        : null
                }
                <Modal
                    isOpen={isOpen}
                    toggle={() => this.toggle()}
                    className='connected-group-to-webdoc-preview-modal'
                    centered
                    size="lg"
                >
                    <ModalHeader toggle={() => this.toggle()}>
                        {'Sync events from CF'.translate(this.props.lang)}
                    </ModalHeader>
                    <ModalBody style={{ paddingTop: 0 }}>
                        <Row>
                            <Col lg="12">
                                <div className='sync-events-from-cf-modal-body-wrap'>
                                    {/* <div className='sync-events-from-cf-modal-body-title'>{'Connected clinic groups to WebDoc'.translate(this.props.lang)}</div> */}
                                    <div className='sync-events-from-cf-mark-unmark-all-wrap'>
                                        <Button color='primary' onClick={() => {
                                            let selectedGroups = [];
                                            if (groups && groups.length > 0) {
                                                selectedGroups = groups.map((group) => group._id);
                                            }
                                            this.setState({ selectedGroups });
                                        }}>
                                            {'Select all'.translate(this.props.lang)}
                                        </Button>
                                        <Button color='primary' onClick={() => {
                                            this.setState({ selectedGroups: [] });
                                        }}>
                                            {'Unselect all'.translate(this.props.lang)} </Button>

                                    </div>
                                    <div className='sync-events-from-cf-modal-body-groups-wrap'>
                                        {
                                            groups.map((item, idx) => {
                                                return (
                                                    <div className='sync-events-from-cf-modal-body-group-item' key={idx}>
                                                        <Checkbox label={item.name} checked={item.selected} onChange={(e) => {
                                                            let selectedGroups = this.state.selectedGroups;
                                                            if (e.target.checked) {
                                                                selectedGroups.push(item._id);
                                                            } else {
                                                                selectedGroups = selectedGroups.filter((id) => id !== item._id);
                                                            }
                                                            this.setState({ selectedGroups });
                                                        }} />
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter className='modal-footer-buttons-wrap' style={{ justifyContent: 'flex-end' }}>
                        <Button color='primary' onClick={() => {
                            this.syncAllNotSyncedEvents();
                        }}>
                            {'Sync all events'.translate(this.props.lang)}
                        </Button>
                        <Button color='primary' onClick={() => {
                            this.checkEventsForSync();
                        }}>
                            {'Check events for sync'.translate(this.props.lang)}
                        </Button>
                        <Button color='primary' onClick={() => {
                            this.toggle();
                        }}>
                            {'Close'.translate(this.props.lang)}
                        </Button>
                    </ModalFooter>
                </Modal>
                {
                    syncedEvents ?
                        <Modal
                            isOpen={syncedEvents}
                            toggle={() => this.setState({ syncedEvents: null })}
                            className='connected-group-to-webdoc-preview-modal'
                            centered
                            size="xl"
                        >
                            <ModalHeader toggle={() => this.setState({ syncedEvents: null })}>
                                {'Synced events'.translate(this.props.lang)}
                            </ModalHeader>
                            <ModalBody >
                                <div className='sync-events-from-cf-modal-body-wrap'>
                                    {
                                        syncedEvents?.map((group, gIdx) => {
                                            const clinics = group.clinics ?? [];
                                            return (
                                                <div className='sync-events-from-cf-modal-body-group-wrap' key={gIdx}>
                                                    <div className='sync-events-from-cf-modal-body-group-title'>{group.name}</div>
                                                    {
                                                        clinics.map((clinic, cIdx) => {
                                                            const doctors = clinic.doctors ?? [];
                                                            return (
                                                                <div className='sync-events-from-cf-modal-body-clinic-wrap' key={cIdx}>
                                                                    <div className='sync-events-from-cf-modal-body-clinic-title'>{clinic.name}</div>
                                                                    {
                                                                        doctors.map((doctor, dIdx) => {
                                                                            const events = doctor.events ?? [];
                                                                            return (
                                                                                <div className='sync-events-from-cf-modal-body-doctor-wrap' key={dIdx}>
                                                                                    <div className='sync-events-from-cf-modal-body-doctor-title'>{doctor.name}</div>
                                                                                    {
                                                                                        events.map((event, eIdx) => {
                                                                                            return (
                                                                                                <div className='sync-events-from-cf-modal-body-event-wrap' key={eIdx}>
                                                                                                    <div className='sync-events-from-cf-modal-body-event-title'>{event.title?.length < 50 ? event?.title : `${event?.title?.substr(0, 50)}...`} <span className='sync-events-from-cf-modal-body-event-description'>- {event?.caseNumber}   ({event.start} - {event.end}) | {event.bookingType}</span></div>
                                                                                                    <Button color={event?.error ? 'danger' : 'primary'} disabled={true} onClick={() => {
                                                                                                    }}>
                                                                                                        {event?.message ?? event?.error ?? null}
                                                                                                    </Button>

                                                                                                </div>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </ModalBody>
                            <ModalFooter className='modal-footer-buttons-wrap' style={{ justifyContent: 'flex-end' }}>

                                <Button color='primary' onClick={() => {
                                    this.setState({ syncedEvents: null })
                                }}>
                                    {'Close'.translate(this.props.lang)}
                                </Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }

                {
                    eventsForSync ?
                        <Modal
                            isOpen={eventsForSync}
                            toggle={() => this.setState({ eventsForSync: null })}
                            className='connected-group-to-webdoc-preview-modal'
                            centered
                            size="xl"
                        >
                            <ModalHeader toggle={() => this.setState({ eventsForSync: null })}>
                                {'Events for sync'.translate(this.props.lang)}
                            </ModalHeader>
                            <ModalBody >
                                <div className='sync-events-from-cf-modal-body-wrap'>
                                    {
                                        eventsForSync?.map((group, gIdx) => {
                                            const clinics = group.clinics ?? [];
                                            return (
                                                <div className='sync-events-from-cf-modal-body-group-wrap' key={gIdx}>
                                                    <div className='sync-events-from-cf-modal-body-group-title'>{group.name}</div>
                                                    {
                                                        clinics.map((clinic, cIdx) => {
                                                            const doctors = clinic.doctors ?? [];
                                                            return (
                                                                <div className='sync-events-from-cf-modal-body-clinic-wrap' key={cIdx}>
                                                                    <div className='sync-events-from-cf-modal-body-clinic-title'>{clinic.name}</div>
                                                                    {
                                                                        doctors.map((doctor, dIdx) => {
                                                                            const events = doctor.events ?? [];
                                                                            return (
                                                                                <div className='sync-events-from-cf-modal-body-doctor-wrap' key={dIdx}>
                                                                                    <div className='sync-events-from-cf-modal-body-doctor-title'>{doctor.name}</div>
                                                                                    {
                                                                                        events.map((event, eIdx) => {
                                                                                            const loading = this.state.loadingSyncEvents.includes(event.eventId);
                                                                                            const syncedResponse = this.state.syncedEventsResponses.find((obj) => obj.eventId === event.eventId);
                                                                                            return (
                                                                                                <div className='sync-events-from-cf-modal-body-event-wrap' key={eIdx}>
                                                                                                    <div className='sync-events-from-cf-modal-body-event-title'>{event.title?.length < 50 ? event?.title : `${event?.title?.substr(0, 50)}...`} <span className='sync-events-from-cf-modal-body-event-description'>- {event?.caseNumber}   ({event.start} - {event.end}) | {event.bookingType}</span></div>
                                                                                                    <Button color='primary' disabled={loading || syncedResponse?.success} onClick={() => {
                                                                                                        this.syncEvent(event);
                                                                                                    }}>

                                                                                                        {'Sync event'.translate(this.props.lang)}
                                                                                                    </Button>
                                                                                                    {
                                                                                                        syncedResponse ?
                                                                                                            <div className='sync-events-from-cf-modal-body-event-synced-response'>
                                                                                                                {syncedResponse.success ? 'Synced successfully'.translate(this.props.lang) : syncedResponse?.message ?? 'Failed to sync'.translate(this.props.lang)}
                                                                                                            </div>
                                                                                                            : null
                                                                                                    }
                                                                                                </div>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </ModalBody>
                            <ModalFooter className='modal-footer-buttons-wrap' style={{ justifyContent: 'flex-end' }}>
                                <Button color='primary' onClick={() => {
                                    this.syncAllNotSyncedEvents();
                                }}>
                                    {'Sync all'.translate(this.props.lang)}
                                </Button>
                                <Button color='primary' onClick={() => {
                                    this.setState({ eventsForSync: null })
                                }}>
                                    {'Close'.translate(this.props.lang)}
                                </Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
            </div>
        );
    }
}



export default SyncEventsFromCF;
